/**
 * cx.url
 * 类-URL工具
 *
 * @class
 * @memberof    cx
 * @author      Zhang Fayong
 * @since       2018-08-20
 */
class Url
{
  /**
	 * 生成http请求的url字符串
   * @static
   * @method
   * @param   {String}    url               url
   * @param   {Object}    params            可变参数
   * @returns {String}
	 */
  static getRequestUrl(url, ...params)
  {
    let ret = url + '?'
    let param, key, count = 0

    for (param of params)
    {
      if (!param)
        continue
      for (key in param)
      {
        ret += (count > 0 ? '&' : '') + key + '=' + param[key]
        count++
      }
    }
    return ret
  }

  static getUrl(url)
  {
    const Ip = window.location.hostname
    const productIpList = ['121.37.140.186', '113.12.121.21', '10.7.64.82', 'www.camining.cn', 'camining.cn']
    return productIpList.includes(Ip) ? url : `svr/${url}`
  }

  /**
	 * 获取http请求的url中的?后的参数
   * @static
   * @method
   * @param     {String}    url               url
   * @returns   {Object}                      可变参数
   * @returns   {Object}    returns.baseUrl   ?前的基础url
   * @returns   {Object}    returns.params    解析的参数对象
	 */
  static getUrlParams(url)
  {
    let ret = {baseUrl: '', params: {}}
    let temp = url.split('?')
    ret.baseUrl = temp[0]
    if (temp[1])
    {
      let arr = temp[1].split('&')
      arr.forEach(item =>
      {
        let temp = item.split('=')
        ret.params[temp[0]] = temp[1]
      })
    }

    return ret
  }

  /**
   * 取url里面的键值
   * @static
   * @method
   * @param   {String}    url               url
   * @param   {String}    key               键值
   * @returns {String}                      值
   */
  static querySearch(url, key)
  {
    let reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)', 'i')
    let r = url.match(reg)
    if (r)
      return r[2]
    return ''
  }

  /**
   * Get方式打开网址
   * @static
   * @method
   * @param   {String}    url               url
   */
  static open(url)
  {
    window.open(url)
  }

  /**
   * 下载网址
   * @static
   * @method
   * @param   {String}    url               url
   */
  static download(url)
  {
    let domA = document.createElement('a')    //创建一个a标签,用做后面的模拟点击下载操作。
    domA.href = url              //绑定a标签的下载地址
    domA.click()                  //模拟点击实现下载
  }
}

export default Url



// WEBPACK FOOTER //
// ./src/lib/Url.js